module.exports = __webpack_public_path__ + "static/3-7dd9fdcbcfd85df0086a47e2834cb993.jpg";